import type { IFieldConfiguration } from '@sravni/cosago-react-library/lib/types';

import type { TPledgeEstateFields } from 'entities/pledgeEstateForm';

import {
  IsOnlyOwnerCheckbox,
  OtherOwnerPhone,
  OtherOwnerFioField,
  OtherOwnerMaritalStatus,
  OtherOwnerRelationship,
  PledgeAddressFlat,
  PledgeAddress,
  PledgeAddressIsRegistrationCheckbox,
} from './fields';

export interface IPledgeAutoMobileConfig extends Omit<IFieldConfiguration, 'fieldName'> {
  fieldName: keyof TPledgeEstateFields;
}

export const FormFieldsControls: Record<keyof TPledgeEstateFields, React.ReactNode> = {
  pledgeEstateAddress: PledgeAddress,
  isOnlyOwner: IsOnlyOwnerCheckbox,
  otherOwnerFullName: OtherOwnerFioField,
  otherOwnerPhone: OtherOwnerPhone,
  otherOwnerMaritalStatus: OtherOwnerMaritalStatus,
  relationship: OtherOwnerRelationship,
  pledgeEstateAddressFlat: PledgeAddressFlat,
  isPledgeAddressSameRegistration: PledgeAddressIsRegistrationCheckbox,
};

export const FormFieldsNavigationSequence: IPledgeAutoMobileConfig[] = [
  {
    fieldName: 'pledgeEstateAddress',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'pledgeEstateAddressFlat',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'isOnlyOwner',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'otherOwnerFullName',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'otherOwnerPhone',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'otherOwnerMaritalStatus',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'relationship',
    required: false,
    checkShouldMoveToNextField: false,
  },
];
